import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['overlay', 'aside']

  show() {
    this.overlayTarget.classList.remove('hidden')
    requestAnimationFrame(() => {
      this.overlayTarget.classList.remove('opacity-0')
      this.asideTarget.classList.remove('translate-x-full')
    })
  }

  close() {
    this.overlayTarget.classList.add('opacity-0')
    this.asideTarget.classList.add('translate-x-full')
    setTimeout(() => this.overlayTarget.classList.add('hidden'), 200)
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }

  keep(event) {
    event.stopPropagation()
  }
}
